export default __webpack_public_path__ + "static/media/accounting.b7bcf2fc.jpg";